import { removeAllTags, removeTag } from 'shared/store/data/filters/actions';

import { boundActionsFactory } from './useBoundActions';

export const useTagsActions = boundActionsFactory({
  removeAllTags,
  removeTag,
});
